import DialogContent from '@mui/material/DialogContent';
import { makeStyles } from '@mui/styles';
import Modal from 'components/Modal/Modal';
import React, { useState, useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getConnections } from 'store/modules/settings/actions';
import { formatPhoneNumber } from 'utils';
import toast from 'utils/toast';
import AddConnectionForm from './AddConnectionForm';

const useStyles = makeStyles(() => ({
  paper: {
    overflow: 'visible',
  },
}));

const AddConnectionModal = ({ history }) => {
  const classes = useStyles();
  const [t] = useTranslation('settings');
  const dispatch = useDispatch();
  const account = useSelector((s) => s.settings.account);

  const onConnectionSaved = ({ phone_number }) => {
    toast.success(
      t('connection-add-success', {
        defaultValue: '{{number}} successfully assigned to your account.',
        number: formatPhoneNumber(phone_number),
      }),
    );
    dispatch(getConnections({ account_id: account.account_id }));
    onClose();
  };

  const onClose = () => {
    history.goBack();
  };

  return (
    <Modal maxWidth="sm" onClose={onClose} classes={{ paper: classes.paper }}>
      <DialogContent className={classes.paper}>
        <AddConnectionForm onConnectionSaved={onConnectionSaved} />
      </DialogContent>
    </Modal>
  );
};

export default AddConnectionModal;
